"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SeverityMarkdownDirectiveDefinition = void 0;
exports.formatSeverityDirective = formatSeverityDirective;
exports.parseSeverityDirectiveValue = parseSeverityDirectiveValue;
const severity_names_1 = require("../RequirementsV2/severity-names");
const MarkdownDirectiveDefinition_1 = require("./MarkdownDirectiveDefinition");
exports.SeverityMarkdownDirectiveDefinition = Object.freeze({
    allowedAttributes: ['severity'],
    contentAttributeName: 'severity',
    directive: 'severity',
    nodeTypes: [MarkdownDirectiveDefinition_1.NodeTypes.TextDirective],
});
function formatSeverityDirective(severity) {
    return `:${exports.SeverityMarkdownDirectiveDefinition.directive}[${(0, severity_names_1.friendlyNameFromSeverity)(severity)}]`;
}
function parseSeverityDirectiveValue(value) {
    const normalized = value.trim().toLowerCase();
    const name = severity_names_1.FRIENDLY_SEVERITY_NAMES.find((candidate) => candidate === normalized);
    return name === undefined ? undefined : (0, severity_names_1.severityFromFriendlyName)(name);
}
//# sourceMappingURL=SeverityReference.js.map